export default "__VITE_ASSET__31dab070__"